import { AuthProvider } from "react-admin";

// Use VITE_API_URL for production (split architecture: Vercel → Railway)
// Empty string means same-origin (local development)
const apiUrl = import.meta.env.VITE_API_URL || "";

/**
 * Auth provider for react-admin that integrates with our Express session auth
 */
export const authProvider: AuthProvider = {
  // Called when user submits login form
  login: async ({ username, password }) => {
    const response = await fetch(`${apiUrl}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
      credentials: "include",
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Login failed");
    }

    const user = await response.json();
    localStorage.setItem("user", JSON.stringify(user));
    return Promise.resolve();
  },

  // Called when user clicks logout
  logout: async () => {
    await fetch(`${apiUrl}/api/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
    localStorage.removeItem("user");
    return Promise.resolve();
  },

  // Called when API returns 401/403
  checkError: async (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("user");
      return Promise.reject();
    }
    return Promise.resolve();
  },

  // Called when user navigates to any page
  checkAuth: async () => {
    const response = await fetch(`${apiUrl}/api/auth/me`, {
      credentials: "include",
    });

    if (!response.ok) {
      localStorage.removeItem("user");
      return Promise.reject();
    }

    const user = await response.json();
    localStorage.setItem("user", JSON.stringify(user));
    return Promise.resolve();
  },

  // Called to get user identity (username, avatar, etc.)
  getIdentity: async () => {
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      return Promise.reject();
    }
    
    const user = JSON.parse(userStr);
    return Promise.resolve({
      id: user.id,
      fullName: user.username,
    });
  },

  // Called to get user permissions (not used in this app)
  getPermissions: async () => {
    return Promise.resolve("admin");
  },
};

export default authProvider;

